// ログイン: メールアドレスにログインリンクを送る。文言・placeholder は旧 e2e の約束に合わせる。
import { useState } from 'react';
import { Navigate, useSearchParams } from 'react-router';
import { Mail } from 'lucide-react';
import { loadSession, safeNextPath, startMagicLink } from '../lib/auth';
import { messageOf } from '../lib/errors';
import { Button, Card, ErrorText, Input, Muted } from '../components/ui';

export function LoginPage() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (loadSession()) return <Navigate to={safeNextPath(params.get('next'))} replace />;

  const submit = async () => {
    setSending(true);
    setError(null);
    try {
      await startMagicLink(email);
      setSent(true);
    } catch (e) {
      setError(messageOf(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="flex min-h-dvh items-center justify-center bg-sidebar px-4">
      <Card className="w-full max-w-sm space-y-4 p-6">
        <div>
          <div className="text-2xl font-semibold tracking-tight text-accent">Alfine</div>
          <Muted>メールアドレスにログインリンクを送ります。</Muted>
        </div>
        {sent ? (
          <div data-testid="login-sent" role="status" className="space-y-2">
            <p className="flex items-center gap-2 font-medium text-ink-1">
              <Mail size={18} className="text-accent" />
              メールを送りました
            </p>
            <Muted>{email} に届いたリンクを開いてください。別の端末で開いても続けられます。</Muted>
            <Button variant="ghost" size="sm" onClick={() => setSent(false)}>
              アドレスを入れ直す
            </Button>
          </div>
        ) : (
          <form
            className="space-y-3"
            onSubmit={(e) => {
              e.preventDefault();
              void submit();
            }}
          >
            <label className="block space-y-1">
              <span className="text-sm text-ink-2">メールアドレス</span>
              <Input data-testid="login-email" type="email" autoComplete="email" required placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} />
            </label>
            <ErrorText>{error}</ErrorText>
            <Button data-testid="login-submit" type="submit" className="w-full" disabled={sending || !email.trim()}>
              {sending ? '送信中…' : 'ログインリンクを送る'}
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}
